import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { Save } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/Index";
import { tokens } from "../../../../theme";

interface StepHeaderProps {
  title: string;
  isEdit?: boolean;
  onUpdate?: () => void;
  submitting?: boolean;
}

const StepHeader: React.FC<StepHeaderProps> = ({
  title,
  isEdit = false,
  onUpdate,
  submitting = false,
}) => {
  const theme = useTheme();
  const themeState = useSelector((state: RootState) => state.theme);
  const colors = tokens(theme.palette.mode, themeState);
  const isDarkMode = theme.palette.mode === "dark";

  const color400 = colors.primary[400] || "#724E41";
  const color10 = colors.primary[10] || "#C29363";
  const textMain = isDarkMode ? "#ffffff" : "#1A202C";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 4,
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, color: textMain, fontSize: "22px" }}
      >
        {title}
      </Typography>

      {isEdit && onUpdate && (
        <Button
          onClick={onUpdate}
          disabled={submitting}
          startIcon={
            submitting ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <Save sx={{ fontSize: "16px !important" }} />
            )
          }
          sx={{
            background: `linear-gradient(135deg, ${color400} 0%, ${color10} 100%)`,
            color: "#fff",
            fontWeight: 600,
            fontSize: "13px",
            textTransform: "none",
            borderRadius: "10px",
            px: 2.5,
            py: 0.9,
            boxShadow: isDarkMode ? "none" : `0px 4px 12px ${color400}33`,
            "&:hover": { opacity: 0.9 },
            "&.Mui-disabled": { opacity: 0.5 },
          }}
        >
          {submitting ? "Saving..." : "Update Booking"}
        </Button>
      )}
    </Box>
  );
};

export default StepHeader;
